import React, {useEffect, useRef, useState} from "react";
import VisibilitySensor from 'react-visibility-sensor';
import playButton from './images/play-button-svgrepo-com.svg'

function Image({imageFile, onClick, imageIdsForNewActivity, hideVisibilitySensor, showVideoCoverImage, shouldBeOpaque, playWhenVisible}) {
    const [isVisible, setIsVisible] = useState(true)
    const [isHovered, setIsHovered] = useState(false)
    const [hasStartedVideo, setHasStartedVideo] = useState(false)
    const videoRef = useRef(null);

    useEffect(() => {
        if (isHovered && videoRef?.current && !playWhenVisible) {
                var playPromise = videoRef.current.play();

                if (playPromise !== undefined) {
                    playPromise.then(_ => {
                        // Automatic playback started!
                        // Show playing UI.
                        // We can now safely pause video...
                        // videoRef.current.pause();
                    })
                        .catch(error => {
                            // Auto-play was prevented
                            // Show paused UI.
                        });
                }
            } else if (!isHovered && !playWhenVisible && videoRef?.current) {
            if (videoRef.current?.play) {
                videoRef.current.pause();
            }
        }
    }, [isHovered])

    useEffect(() => {
        if (!isVisible && videoRef?.current && playWhenVisible) {
            if (videoRef.current?.play) {
                videoRef.current.pause();
            }
        } else if (isVisible && playWhenVisible && videoRef?.current) {
            videoRef.current.muted = true
            videoRef.current?.play()
        }
    }, [isVisible])

    useEffect(() => {
        if (videoRef?.current && !hasStartedVideo) {
            videoRef.current.muted = true
            videoRef.current?.play()
            setHasStartedVideo(true)
            setTimeout(() => {
                videoRef.current.muted = false
                videoRef.current.pause();
            }, 100)
        }

    }, [videoRef?.current])

    const style = {}

    if (imageIdsForNewActivity.includes(imageFile.id) || shouldBeOpaque) {
        style.opacity = 0.5
    }


    const imageContainer = (
        <div className="view-trip-image-div" onClick={() => onClick(imageFile)}
             key={imageFile?.id} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}
        >
            {/*{imageFile?.videoCoverImage ? (<div className="play-button">*/}
            {/*    <img src={playButton} style={style}/>*/}
            {/*</div>) : null}*/}

            {(imageFile.fileType?.includes("video") ? <video
                    src={imageFile.video_location}
                    className="view-trip-image"
                    style={style}
                    controls
                    ref={videoRef}
                    preload="none"
                    // muted
                /> :
                <img src={imageFile.image_location} className="view-trip-image"
                     style={style}/>
            )}
        </div>
    )

    return (
        <VisibilitySensor partialVisibility onChange={(isVisible) => {
            setIsVisible(isVisible)
            // if (isVisible) {
            //     if (videoRef?.current) {
            //         videoRef.current.play()
            //         setTimeout(() => {
            //             videoRef.current.pause()
            //         }, 100)
            //     }
            // }
        }}
        >
            {imageContainer}
        </VisibilitySensor>
    )
}

export default Image;